// =============================================================================
// File: searchai-session-client.js
// =============================================================================

// Define the global namespace early (Legacy Access Point)
window.SearchAI = window.SearchAI || {};


// ================================
// Session Module
// ================================

// Define the core methods for the Session module
const SESSION_KEY = 'searchai_session_id';
const EXPIRATION_MINUTES = 1440; // expires after 24 hours

// A/B Test Group Constants
const SEARCH_GROUP_AI = 'ai';
const SEARCH_GROUP_SHOPIFY = 'shopify';

/**
 * Creates a new, unique session object.
 */
function createNewSession() {
  const group = Math.random() < 0.5 ? SEARCH_GROUP_AI : SEARCH_GROUP_SHOPIFY;
  console.log(`[A/B TEST] 🎲 NEW SESSION - Assigned to: ${group.toUpperCase()} group`);

  return {
    id: 'sess_' + Math.random().toString(36).substring(2) + Date.now(),
    created_at: Date.now(),
    search_group: group
  };
}

function validateSession() {
  let sessionData = localStorage.getItem(SESSION_KEY);
  let sessionObj;
  let ageMinutes = 0; // Initialize for debugging

  if (sessionData) {
    sessionObj = JSON.parse(sessionData);
    ageMinutes = (Date.now() - sessionObj.created_at) / (1000 * 60);

    // Check if expired OR if search_group is missing (old session format)
    if (ageMinutes > EXPIRATION_MINUTES || !sessionObj.search_group) {
      sessionObj = createNewSession();
    }
  } else {
    sessionObj = createNewSession();
  }

  localStorage.setItem(SESSION_KEY, JSON.stringify(sessionObj));
  return sessionObj;
}

/**
 * Retrieves the current valid Session ID from localStorage, refreshing if expired.
 * @returns {string} The current session ID.
 */
function getSessionId() {
  const sessionObj = validateSession();
  return sessionObj.id;
}

/**
 * Gets the A/B test search group for the current session.
 * @returns {string} SEARCH_GROUP_AI or SEARCH_GROUP_SHOPIFY
 */
function getSearchGroup() {
  const sessionObj = validateSession();
  const group = (sessionObj && sessionObj.search_group) ? sessionObj.search_group.toUpperCase() : 'UNKNOWN';
  console.log('[SESSION] 📋 Current session group: ' + group);
  return sessionObj.search_group;
}

/**
 * Checks if the current session should use AI search.
 * @returns {boolean} True if AI search should be used, false for Shopify search.
 */
function isAISearchGroup() {
  return getSearchGroup() === SEARCH_GROUP_AI;
}


// ================================
// Client Module (Refactored Core)
// ================================
const CLIENT_KEY = 'search-ai-client-id';

/**
 * Retrieves a persistent, unique Client ID from localStorage, creating one if it doesn't exist.
 * @returns {string} The current client ID.
 */
function getClientId() {
  let id = localStorage.getItem(CLIENT_KEY);
  if (!id) {
    // If no client ID exists, generate a new one and store it.
    id = 'client_' + Math.random().toString(36).substring(2) + Date.now();
    localStorage.setItem(CLIENT_KEY, id);
  }
  return id;
}

// Expose Session Module globally
window.SearchAI.Session = {
  getSessionId: getSessionId,
  getSearchGroup: getSearchGroup,
  isAISearchGroup: isAISearchGroup
};

// Expose Client Module globally
window.SearchAI.Client = {
  getClientId: getClientId
};

// Log initialization
console.log('%c[SearchAI] ✅ Session and Client modules initialized', 'background: #4CAF50; color: white; padding: 3px;');
